import styled from 'styled-components';
import { Molecule } from 'AppReact';
import { UnderlinedTabButton } from 'atoms'
import Text from 'atoms/text';

const template = styled.div`
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 12px;
  padding-right: 12px;
  border: 1px solid #E3E3E3;
  border-radius: 8px 8px 0px 0px;

  border-bottom-width: 0px;
`

export default Molecule({
  type: 'formgroup',
  template,
  atoms: [
    {
      component: Text,
      name: 'SelectedText',
      displayValue: ({ selectedPersonsIds }) => `${selectedPersonsIds.length} Selected`
    },
    {
      component: UnderlinedTabButton,
      name: 'ClearButton',
      displayValue: ({ selectedPersonsIds }) => selectedPersonsIds.length > 0 ? 'Clear All' : 'Select All'
    }
  ]
})